// ─────────────────────────────────────────────────────────────────────────────
// Formatos de la barra del editor: insertan Markdown en la posición del cursor
// del textarea. Puras: reciben el texto y la selección y devuelven el texto
// nuevo y dónde dejar la selección.
// ─────────────────────────────────────────────────────────────────────────────

function wrap(value, start, end, marker, placeholder) {
  const selected = value.slice(start, end) || placeholder;
  const next = `${value.slice(0, start)}${marker}${selected}${marker}${value.slice(end)}`;
  const selStart = start + marker.length;
  return { value: next, selStart, selEnd: selStart + selected.length };
}

function insert(value, start, end, text) {
  const next = `${value.slice(0, start)}${text}${value.slice(end)}`;
  const caret = start + text.length;
  return { value: next, selStart: caret, selEnd: caret };
}

/**
 * @param {string} value
 * @param {number} start  selectionStart
 * @param {number} end    selectionEnd
 * @param {"bold"|"italic"|"list"|"link"|"image"} kind
 * @param {{ url?: string, text?: string }} [extra]
 */
export function applyFormat(value, start, end, kind, extra = {}) {
  const from = Math.max(0, Math.min(start, end));
  const to = Math.max(from, Math.max(start, end));

  switch (kind) {
    case "bold":
      return wrap(value, from, to, "**", extra.text || "texto");
    case "italic":
      return wrap(value, from, to, "_", extra.text || "texto");
    case "list": {
      // Desde el inicio de la primera línea seleccionada hasta el fin de la última.
      const lineStart = value.lastIndexOf("\n", from - 1) + 1;
      const lineEnd = value.indexOf("\n", to) === -1 ? value.length : value.indexOf("\n", to);
      const block = value.slice(lineStart, lineEnd) || extra.text || "elemento";
      const listed = block
        .split("\n")
        .map((line) => (line.startsWith("- ") ? line : `- ${line}`))
        .join("\n");
      const next = `${value.slice(0, lineStart)}${listed}${value.slice(lineEnd)}`;
      return { value: next, selStart: lineStart, selEnd: lineStart + listed.length };
    }
    case "link": {
      const text = value.slice(from, to) || extra.text || "texto del link";
      return insert(value, from, to, `[${text}](${extra.url || ""})`);
    }
    case "image": {
      // Una imagen va sola en su línea.
      const before = from > 0 && value[from - 1] !== "\n" ? "\n" : "";
      const after = to < value.length && value[to] !== "\n" ? "\n" : "";
      const alt = (extra.text || "imagen").replace(/[[\]]/g, "");
      return insert(value, from, to, `${before}![${alt}](${extra.url || ""})${after}`);
    }
    default:
      return { value, selStart: start, selEnd: end };
  }
}
